import { useCallback, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import QCXFinalFormDialog from '../../shared-components/dialog/QCXFinalFormDialog';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalDatePickerField from '../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import { CLOSED_STATUS, isOpenStatus } from '../../utils/hooks/form/dialog/formDialogUtils';

// o confirmar só libera com número da nota e data de emissão válida preenchidos
const isPreenchimentoIncompleto = ({ values }) =>
  !values?.numeroNota?.trim() || !values?.dataEmissao || !moment(values.dataEmissao).isValid();

export default function QCXFaturamentoAlterarNfseDialogForm({
  handleOnSubmit,
  handleFormStatus,
  formDialogStatus,
  initialValues,
}) {
  const { t } = useTranslation();

  const isFormDialogOpen = useMemo(() => isOpenStatus(formDialogStatus), [formDialogStatus]);

  const handleCloseFormDialog = useCallback(() => {
    handleFormStatus(CLOSED_STATUS);
  }, [handleFormStatus]);

  return (
    <QCXFinalFormDialog
      key="form-dialog-alterar-nfse"
      id="form-dialog-alterar-nfse"
      title={t('com.muralis.qcx.alterarNFSe')}
      dialogActionsProps={{
        button: {
          submit: {
            description: t('com.muralis.qcx.acoes.confirmar'),
            size: 'small',
            color: 'secondary',
          },
          cancel: {
            description: t('com.muralis.qcx.acoes.cancelar'),
            size: 'small',
          },
        },
      }}
      open={isFormDialogOpen}
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      onClose={handleCloseFormDialog}
      submitDisabled={isPreenchimentoIncompleto}
    >
      {() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFinalTextField
              id="text-field-numero-nota-servico"
              key="text-field-numero-nota-servico"
              name="numeroNota"
              label={t('com.muralis.qcx.numeroNotaServico')}
              maxLength={255}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFinalDatePickerField
              id="date-picker-data-emissao-nfse"
              key="date-picker-data-emissao-nfse"
              name="dataEmissao"
              label={t('com.muralis.qcx.dataEmissao')}
              required
            />
          </Grid>
        </Grid>
      )}
    </QCXFinalFormDialog>
  );
}
